<template>
    <button type="button" ref="example@gmail.com" @click="copyText" class="theme-btn theme-btn-white">
        <i class="lar la-copy copy-icon"></i>
        {{ isCopied ? 'Copied!' : 'Copy Email'}}
    </button>
</template>

<script>
export default {
    name: 'CopyButton',
    props: ['text'],
    data() {
        return {
            isCopied: false
        }
    },
    methods: {
        copyText() {
            const copyTx = this.text ? this.text : 'example@gmail.com';
            navigator.clipboard.writeText(copyTx);
            this.isCopied = true;
            setTimeout(() => {
                this.isCopied = false;
            }, 700)
        }
    }
}
</script>